module.exports = __webpack_public_path__ + "28ac81b7500e754eb92a7c2294e9791e.pdf";